import { motion, AnimatePresence } from 'framer-motion'
import React from 'react'
import { useCartState, useCartDispatch } from '@/contexts/CartContext'
import { applyCoupon, removeCoupon } from 'CartActions'
import { toast } from 'react-hot-toast'
import CustomToast from '../CustomToast'
import alerts from '@/config/alerts.json'

const Loader = () => (
  <div className='w-full h-full flex justify-center items-center'>
    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
  </div>
)

const CouponForm = ({
  isCouponLoading,
  setIsCouponLoading,
}: {
  isCouponLoading: boolean
  setIsCouponLoading: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const [coupon, setCoupon] = React.useState('')
  const cart = useCartState()
  const cartDispatch = useCartDispatch()

  const sleep = (ms: number) => new Promise(res => setTimeout(res, ms))

  const SubmitCoupon = async () => {
    setIsCouponLoading(true)
    try {
      if (coupon.trim() === '') {
        toast.custom((t) => <CustomToast t={t} message={alerts.coupon_empty} type='success' />,{       
          duration: 500 
        });
        setCoupon('')
        return
      }
      await sleep(500);
      cartDispatch(applyCoupon(coupon))
    } finally {
        await sleep(1100);
        setIsCouponLoading(false)
    }
  }

  const handleRemoveCoupon = async () => {
    setIsCouponLoading(true)
    try {
        await sleep(500);
        cartDispatch(removeCoupon())
        setCoupon('')
    } finally {
        await sleep(1000);
        setIsCouponLoading(false)
    }
  }

  React.useEffect(() => {
    if (cart.coupon) {
        setCoupon(cart.coupon);
    }
  }, [cart])
  return (
    <div>
      <form
        onSubmit={e => {
          e.preventDefault()
          cart.coupon ? handleRemoveCoupon() : SubmitCoupon()
        }}
        className="flex justify-between items-center mt-2 py-1 px-2 md:p-2 border rounded-lg border-gray-200"
      >
        <input
          type="text"
          placeholder="ادخل كود الخصم"
          className="flex-1 py-[1px] text-sm border border-white focus:outline-none focus:ring-0 focus:border-white focus:border-0"
          disabled={!!cart.coupon}
          value={coupon}
          onChange={e => setCoupon(e.target.value)}
        />
        <AnimatePresence mode="wait">
          {cart.coupon ? (
            <motion.button
              type="submit"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.2 }}
              className="bg-red text-white rounded-lg px-2 py-1 flex items-center justify-center w-12 h-8 text-xs md:text-sm md:w-16 md:h-8"
            >
              {isCouponLoading ? <Loader /> : 'الغاء'}
            </motion.button>
          ) : coupon.length > 0 && (
            <motion.button
              type="submit"
              key={isCouponLoading ? 'loading' : 'default'}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.2 }}
              className="bg-emerald-400 text-white rounded-lg px-2 py-1 flex items-center justify-center w-12 h-8 text-xs md:text-sm md:w-16 md:h-8"
            >
              {isCouponLoading ? <Loader /> : 'تفعيل'}
            </motion.button>
          )}
        </AnimatePresence>
      </form>
    </div>
  )
}

export default CouponForm